module.exports = __webpack_public_path__ + "img/tarj-cryptoinversiones.32dbe381.png";